import { render } from "./OrganizationSettings.vue?vue&type=template&id=02ae0d8c&scoped=true"
import script from "./OrganizationSettings.vue?vue&type=script&lang=js"
export * from "./OrganizationSettings.vue?vue&type=script&lang=js"

import "./OrganizationSettings.vue?vue&type=style&index=0&id=02ae0d8c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ae0d8c"]])

export default __exports__